export default "__VITE_ASSET__5dc17fa0__"